import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-sort-icon',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './sort-icon.component.html',
    styleUrl: './sort-icon.component.css'
})
export class SortIconComponent {
    @Input() order: 'asc' | 'desc' = 'desc';
}
